import api from "@/services/api";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";


const PremiumProviderInvitation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // Assuming the token is passed as a query parameter
  const isexist = searchParams.get('isexist'); // Assuming the isExisting flag is passed as a query parameter
  const agencyId = searchParams.get('aid'); // Assuming the isExisting flag is passed as a query parameter
  const email = searchParams.get('email'); // Assuming the isExisting flag is passed as a query parameter

  const handleDecline = () => {
    // go to login page
    navigate('/provider-login');
  }

  const handleAccept = async () => {
    if (isexist === "0") {
      // go to provider create account page and pass the token as query parameter
      navigate(`/provider-create-account?token=${token}&agencyId=${agencyId}&email=${email}`);
    } else if (isexist === "1") {
      // call token api and go to provider login call axios instance
      try {
        const response = await api.post('/provider-invitations/accept', {
          token
        });
        if (response.data.message === "Invitation accepted successfully") {
          navigate(`/provider-login`);
          // i want to show real message
          toast.success(response.data.message || "Invitation accepted successfully");
        } else {
          toast.error(response.data.message || "Failed to accept invitation");
        }
      } catch (error) {
        toast.error("Error validating token:", error?.response?.data?.message || error.message || "An error occurred");
      }
    }
  }
  return (
    <div className="relative flex items-center justify-center min-h-screen bg-[#f8f9fc] overflow-hidden antialiased">

      {/* Dynamic Luxury Ambient Glow Behind Card */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[#7A6FA1]/10 blur-[120px]" />

      {/* Ultra-Premium Glassmorphic Card */}
      <div className="relative bg-white p-10 rounded-[24px] w-full max-w-md border border-[#E5E7EB] shadow-[0_10px_40px_rgba(122,111,161,0.12)]">

        {/* Subtle top reflective border light line */}
        <div className="absolute top-0 left-6 right-6 h-[1px] bg-gradient-to-r from-transparent via-[#9D87F5]/30 to-transparent" />

        {/* Premium Icon Header - Abstract luxury geometric shield */}
        <div className="mb-8 flex items-center justify-center w-16 h-16 rounded-2xl bg-[#EDE9F8] border border-[#D9D1F0]">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#A294E3]">
            <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 11V15M12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        {/* Typography Section */}
        <h2 className="text-2xl font-semibold tracking-tight text-[#3F3A5A] mb-3 font-sans">
          Exclusive Invitation
        </h2>

        <p className="text-[14px] leading-relaxed text-[#9895A6] mb-8 font-light tracking-wide">
          You have been granted priority access to join our network as a verified provider. Unlock your premium dashboard and elite features.
        </p>

        {/* Luxury CTA Array */}
        <div className="flex flex-col gap-3 w-full">
          {/* Primary Action: Shimmer / Glowing Button */}
          <button className="relative overflow-hidden w-full bg-gradient-to-b from-[#8B77E0] to-[#6B57C4] hover:from-[#9986ED] hover:to-[#7762D1] text-white font-medium text-sm py-3.5 px-4 rounded-xl shadow-[0_4px_20px_rgba(107,87,196,0.3)] hover:shadow-[0_4px_25px_rgba(107,87,196,0.5)] active:scale-[0.99] transition-all duration-200 cursor-pointer" onClick={handleAccept}>
            {/* Elegant text layout */}
            <span className="relative z-10 tracking-wide" >
              Accept & Initialize Workspace
            </span>
            {/* Subtle inner sheen overlay */}
            <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full animate-[shimmer_2.5s_infinite]" />
          </button>

          {/* Secondary Action: Minimal Text / Ghost Button */}
          <button className="w-full bg-transparent hover:bg-[#9895A6]/5 active:scale-[0.99] text-[#7A778A] hover:text-[#9895A6] font-medium text-sm py-3 px-4 rounded-xl transition-all duration-200 tracking-wide cursor-pointer" onClick={handleDecline}>
            Decline Offer
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumProviderInvitation;